export default '6.40.0';